import { ObjectTools, SolActiveRouteStatus } from '@sol/components';

export class AppState {
  private constructor(public readonly activeRouteStatus: SolActiveRouteStatus) {}
  public static of(): AppState {
    return new AppState('loading');
  }
  public withNavigation(activeRouteStatus: SolActiveRouteStatus): AppState {
    return this.copy({ activeRouteStatus });
  }

  private copy(props: Partial<AppState>): AppState {
    return ObjectTools.copy<AppState>(this, props);
  }
}
